import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCheckboxOn = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.01819 2C3.79901 2 2 3.78902 2 5.9959L2 18.0041C2 20.211 3.79901 22 6.01819 22H17.9818C20.201 22 22 20.211 22 18.0041V5.9959C22 3.78903 20.201 2 17.9818 2H6.01819ZM16.5759 10.5339C16.8701 10.2413 16.8701 9.76692 16.5759 9.47433C16.2817 9.18173 15.8046 9.18173 15.5104 9.47433L11.0204 13.9394L8.53952 11.4723C8.24529 11.1797 7.76826 11.1797 7.47403 11.4723C7.17981 11.7649 7.17981 12.2393 7.47403 12.5318L11.0204 16.0586L16.5759 10.5339Z" }),
});

export { IconCheckboxOn };
